// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import petitionResponseEntity from './entities/petition-response.json';
import petitionResponseMenu from '../pages/petition-response/menu.json';
import petitionResponseFullForm from '../pages/petition-response/forms/full.json';
import petitionResponseContextForm from '../pages/petition-response/forms/context.json';
import petitionResponseMiniForm from '../pages/petition-response/forms/mini.json';
import petitionResponseLookupForm from '../pages/petition-response/forms/lookup.json';
import petitionResponseTableView from '../pages/petition-response/views/table.json';
import petitionResponseCardsView from '../pages/petition-response/views/cards.json';
import petitionResponseCalendarView from '../pages/petition-response/views/calendar.json';
import petitionResponseDashboardView from '../pages/petition-response/views/dashboard.json';

/** Тип запису «Відповідь на петицію» зі сторінками пакета: меню, форми та подання з pages/petition-response/. */
export const petitionResponseDefinition: IRecordTypeDefinition = {
  ...petitionResponseEntity,
  views: assembleViewSet({
      table: petitionResponseTableView,
      cards: petitionResponseCardsView,
      calendar: petitionResponseCalendarView,
      dashboard: petitionResponseDashboardView,
  }),
  form: petitionResponseFullForm,
  forms: { full: petitionResponseFullForm, context: petitionResponseContextForm, mini: petitionResponseMiniForm, lookup: petitionResponseLookupForm },
  menu: petitionResponseMenu,
} as IRecordTypeDefinition;
